import { render, staticRenderFns } from "./StorePromoModal.vue?vue&type=template&id=5674217e&"
import script from "./StorePromoModal.vue?vue&type=script&lang=js&"
export * from "./StorePromoModal.vue?vue&type=script&lang=js&"
import style0 from "./StorePromoModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports